import React from 'react'
import './ArrowBtn.css'
import { motion } from 'framer-motion'
export default function ArrowBtn(props) {
    return (
        <motion.button
            whileTap={{
                scale: 0.95
            }}
            onClick={props.onClick}
            className='arrow-btn'
            type='button'
        >
            {props.children}
            <div
                className='arrow'
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                    <path d="M7.40061 2.08694C7.26743 2.14246 7.14657 2.22376 7.04488 2.32609C6.94303 2.42825 6.86231 2.54948 6.80725 2.68279C6.75213 2.81626 6.72378 2.95927 6.72378 3.10366C6.72378 3.24804 6.75213 3.39106 6.80725 3.52452C6.86234 3.65791 6.94312 3.7792 7.04506 3.8814C7.04512 3.88146 7.04517 3.88152 7.04523 3.88158L14.6294 11.5L7.0449 19.1187L7.04488 19.1188C6.8393 19.3253 6.72414 19.605 6.72414 19.8963C6.72414 20.1876 6.8393 20.4674 7.04488 20.6739C7.25052 20.8805 7.52982 20.9969 7.82145 20.9969C8.11308 20.9969 8.39239 20.8805 8.59803 20.6739L16.9548 12.2779C17.0568 12.1757 17.1377 12.0543 17.1928 11.9209C17.2479 11.7874 17.2763 11.6444 17.2763 11.5C17.2763 11.3556 17.2479 11.2126 17.1928 11.0791C17.1377 10.9457 17.0568 10.8243 16.9548 10.7221L8.59838 2.32645C8.59832 2.32638 8.59825 2.32631 8.59818 2.32624C8.49646 2.22384 8.37554 2.14249 8.24229 2.08694C8.10895 2.03135 7.96593 2.00271 7.82145 2.00271C7.67697 2.00271 7.53396 2.03135 7.40061 2.08694Z" fill="#F5BD45" stroke="#F5BD45" strokeWidth="0.8" />
                </svg>
            </div>
        </motion.button>
    )
}
